module.exports = __webpack_public_path__ + "img/reset.0afb130c.svg";